import { Button } from 'antd';
import styled from 'styled-components';

export const StyledFooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px;
    border-top: 1px solid ${(props) => props.theme.semantic.divider};
`;

export const StyledCancelButton = styled(Button)``;

export const StyledApplyButton = styled(Button)`
    margin-left: 12px;
`;
